<template>
  <div
    v-if="list_material_file.length"
    style="background-color: #fafafa; border-radius: 10px; margin-top: -20px;"
    class="pt-7 pb-5 px-5"
  >
    <v-row>
      <v-col cols="2" v-for="(row, i) of list_material_file" :key="i">
        <v-card class="mx-auto mb-3" max-width="400" flat>
          <v-img
            class="white--text align-end"
            style="cursor: pointer"
            height="150px"
            :src="file_url + row.filename"
            v-if="
              ['jpg', 'png', 'svg', 'jpeg'].includes(getTypeFile(row.filename))
            "
            @click="openMaterialFile(row)"
          />

          <div
            v-if="['pdf'].includes(getTypeFile(row.filename))"
            align="center"
            class="d-flex"
            style="height: 150px; align-items: center; background-color: #ffdcdc;"
          >
            <v-img
              class="white--text align-end"
              height="50px"
              contain
              :src="require('@/assets/pdf.png')"
              @click="openMaterialFile(row)"
            >
            </v-img>
          </div>

          <div
            v-if="['xls', 'xlsx'].includes(getTypeFile(row.filename))"
            align="center"
            class="d-flex"
            style="height: 150px; align-items: center; background-color: #d5f7ea;"
          >
            <v-img
              class="white--text align-end"
              height="50px"
              contain
              :src="require('@/assets/excel.png')"
              @click="openMaterialFile(row)"
            >
            </v-img>
          </div>

          <div
            v-if="['doc', 'docx'].includes(getTypeFile(row.filename))"
            align="center"
            class="d-flex"
            style="height: 150px; align-items: center; background-color: #d5e9f7;"
          >
            <v-img
              class="white--text align-end"
              height="50px"
              contain
              :src="require('@/assets/word.png')"
              @click="openMaterialFile(row)"
            >
            </v-img>
          </div>

          <v-card-text class="text--primary">
            <div
              style="font-size: 11px; line-height: normal; min-height: 40px;"
            >
              {{ row.filename }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn color="red" small text @click="deleteFile(row)">
              Delete
            </v-btn>

            <v-btn color="primary" small text @click="openMaterialFile(row)">
              Open
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-chip
      class="mt-4 mr-2 custom-chip"
      v-for="(row, i) of list_material_file"
      :key="i"
      close
      @click="openMaterialFile(row)"
      @click:close="deleteFile(row)"
    >
      <v-avatar left>
        <v-icon>mdi-file</v-icon>
      </v-avatar>

      {{ row.filename }}
    </v-chip> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: null,
      loading: false,
      message: null,
      list_material_file: [],
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
    }
  },
  mounted() {
    this.getMaterialFile()
  },
  methods: {
    async getMaterialFile() {
      const url = this.base_url + "master/getdata/material_file"

      const data = {
        request_no: this.$attrs.request_no,
        material_number: this.$attrs.material_number,
      }

      try {
        const response = await this.axios.post(url, data)
        this.list_material_file = response.data ? response.data : []
      } catch (err) {
        console(err)
      }
    },

    deleteFile(row) {
      var url = this.base_url + "material/upload/unlinkFile"
      var data = {
        id: row.id,
        filename: row.filename,
        request_no: row.request_number,
      }

      this.$dialog.confirm({
        text: "Are you sure you want to delete this item ?",
        title: "Delete Material File",
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              var self = this
              self.axios
                .post(url, data)
                .then((response) => {
                  if (response.status === 200) {
                    self.getMaterialFile()
                  }
                })
                .catch((error) => {
                  alert("Delete material file failed")
                  console("Error delete file" + error)
                })
            },
          },
        },
      })
    },

    openMaterialFile(item) {
      var url = this.file_url + item.filename

      var filetype = item.filename.split(".")
      var open_attr = ["jpg", "png", "svg", "jpeg"].includes(filetype[1])
        ? "height=500,width=800,resizable=yes,left=300, top=400"
        : ""

      window.open(url, "blank", open_attr)
    },

    getTypeFile(filename) {
      var filetype = filename.split(".")
      return filetype[1]
    },
  },
}
</script>

<style>
.item {
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 10;
  background-color: #f6f6f6;
  padding: 10px 15px;
  font-size: 12px;
}

.footer {
  background-color: #ffffff;
  padding-bottom: 0px;
  box-shadow: 0 1px 6px 0 rgba(49, 53, 59, 0.12);
}

.custom-chip {
  white-space: normal;
  min-height: 50px !important;
}
</style>
